const getCurrentUserId = userAccess =>
  userAccess?.id ||
  userAccess?.userId ||
  userAccess?.user?.id ||
  userAccess?.user?.userId;

export default getCurrentUserId;
